import { Component } from 'react';
import { buildPath, langFromSlug, isValidLangSlug, isLegacyLangSlug } from '../utils/route_utils';

/**
 * Client-side redirect for a retired route inside the language prefix.
 *
 *   <Route path="/:lang/tech/collie" element={<PathRedirect to="/tech/odo" />} />
 *
 * Keeps the language of the current URL (legacy "zh" maps to zh-tw), preserves
 * the query string and hash, and uses location.replace so the retired URL does
 * not stay in history. The CloudFront function returns a real 301 for the same
 * paths; this covers in-app navigation and any edge that missed the rule.
 */
class PathRedirect extends Component {
  componentDidMount() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const first = parts[0] || 'zh-tw';
    const lang = isValidLangSlug(first) ? langFromSlug(first) : (isLegacyLangSlug(first) ? 'zh' : 'zh');
    window.location.replace(buildPath(lang, this.props.to || '/') + window.location.search + window.location.hash);
  }

  render() {
    return null;
  }
}

export default PathRedirect;
